
export const UserIPStore = "UserIPStore";
export const UserIPv6 = "UserIPv6";
export const gclidData = "VLMSgclidData";
export const gclidName = "VLMSgclidName";
export const gclidDate = "VLMSgclidDate";
export const indexurl = "VLMSindexurl";
export const referralLink = "referralLinkDataVLMS";
export const landingPage = "landingPageDataVLMS";
export const countryData = "countryDataVLMS";